import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_WEBSITE_SOCIAL_BASE_URL}/v2/collections`;

export const fetchCollectionDetails = async (identifier) => axios.get(`${baseUrl}/${identifier}`);
